module.exports = __webpack_public_path__ + "static/media/kaspersky_logo.a29ec1f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/kaspersky_logo.png
// module id = 385
// module chunks = 0